import axios from '@/api/config';

const versionManagement = {
  // getRoleById (data) {
  //   return axios.get(`${process.env.BASE_URL}/role/getRole/` + data, {});
  // },
  // getRole (data) {
  //   return axios.get(`${process.env.BASE_URL}/role/getRole`, { params: data });
  // },
  // getRoleList () {
  //   return axios.get(`${process.env.BASE_URL}/role/getRoleList`, {});
  // },
  pageListApp (data) {
    return axios.post(`${process.env.BASE_URL}/appIos/pageList`, data);
  },
  addApp (data) {
    return axios.post(`${process.env.BASE_URL}/appIos/addAppIos`, data);
  },
  updateApp (data) {
    return axios.put(`${process.env.BASE_URL}/appIos/updateAppIos`, data);
  },
  deleteApp (data) {
    console.log(data)
    return axios.delete(`${process.env.BASE_URL}/appIos/deleteAppIos`, { data: data });
  },
  // exportExcel (data) {
  //   return axios.get(`${process.env.BASE_URL}/role/exportExcel`, { params: data });
  // },
  // importData () {
  //   return axios.post(`${process.env.BASE_URL}/role/importData`, data);
  // }
}

export default versionManagement;



// WEBPACK FOOTER //
// ./src/api/versionManagement.js